import { Head } from 'vite-react-ssg';
import { Link } from "react-router-dom";
import { Chrome } from "lucide-react";

const NotFound = () => {
  return (
    <>
      <Head>
        <title>Page Not Found — DeepSeek.ai</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="description" content="The page you're looking for doesn't exist on DeepSeek.ai. Browse our DeepSeek guides, comparisons and news instead." />
      </Head>
      <main className="min-h-[70vh] flex items-center justify-center px-4 pt-24 pb-12">
        <div className="max-w-xl text-center">
          <p className="text-sm font-semibold text-primary mb-2">404</p>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            This page doesn't exist
          </h1>
          <p className="text-lg text-muted-foreground mb-8">
            The URL you tried isn't on DeepSeek.ai. It may have been moved, mistyped, or never existed.
            Try one of the popular pages below.
          </p>
          <div className="flex flex-wrap gap-3 justify-center mb-10">
            <Link to="/" className="px-4 py-2 rounded-full bg-primary text-white text-sm font-medium hover:bg-primary/90">Home</Link>
            <Link to="/blog" className="px-4 py-2 rounded-full bg-secondary text-sm font-medium hover:bg-secondary/80">Blog</Link>
            <Link to="/deepseek-vs-chatgpt" className="px-4 py-2 rounded-full bg-secondary text-sm font-medium hover:bg-secondary/80">DeepSeek vs ChatGPT</Link>
            <Link to="/deepseek-r1" className="px-4 py-2 rounded-full bg-secondary text-sm font-medium hover:bg-secondary/80">DeepSeek R1</Link>
            <Link to="/deepseek-v4" className="px-4 py-2 rounded-full bg-secondary text-sm font-medium hover:bg-secondary/80">DeepSeek V4</Link>
            <Link to="/pricing" className="px-4 py-2 rounded-full bg-secondary text-sm font-medium hover:bg-secondary/80">Pricing</Link>
          </div>
          <a
            href="https://chromewebstore.google.com/detail/ai-sidebar-with-deepseek/inhcgfpbfdjbjogdfjbclgolkmhnooop"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 text-base font-medium rounded-full text-white bg-primary hover:bg-primary/90 shadow"
          >
            <Chrome className="mr-2 h-5 w-5" />
            Get the free Chrome extension
          </a>
        </div>
      </main>
    </>
  );
};

export default NotFound;
